import { companySettingsRoute } from '@/abilities/companySettings/routes';
import { toCompanySettingsDestination } from '@/abilities/companySettings/vocabulary';
import { createDestinationRoute } from '@/router/destinationRoute';
import { companySettingsDestinationRoutes } from '@/pages/configurations/company/destinationRoutes';

export const companySettingsDestinationRoute = createDestinationRoute(
  companySettingsDestinationRoutes,
  toCompanySettingsDestination,
  companySettingsRoute,
);
